export default __webpack_public_path__ + "static/media/pot_banner_desktop.63705aec.png";